import { Helmet } from 'react-helmet-async';
import React from 'react';
import StakeholdersSettingsFormContainer from '../../../containers/projects/StakeholdersSettingsFormContainer.jsx';

import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

const StakeholdersSettings = ({ projectId, slug }) => (
  <>
    <Helmet>
      <title>Stakeholder Analysis Settings | ChangeSync</title>
    </Helmet>
    <StakeholdersSettingsFormContainer projectId={projectId} slug={slug} />
  </>
);

StakeholdersSettings.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(StakeholdersSettings));
